export default __webpack_public_path__ + "assets/images/c0fd71f71b674f5cfc69c83a9bb88640.svg";